import Messages from "../../../../comms/messages/Messages";
import IMessageTabProps from "./IMessageTabProps";

export const MessageTab = (props: IMessageTabProps) => <Messages ticket={props.ticket} showMessages={true} />;